import styles from './PrintBanner.module.css';

/**
 * Branded report header shown only when printing.
 * Hidden on screen via CSS; no extra wrapper needed.
 *
 * Props
 *   companyInfo  { name, address, website, logo }
 *   reportTitle  string
 *   dateRange    string   (optional chip)
 *   course       string   (optional chip)
 *   generatedOn  string   (optional chip)
 */
export default function PrintBanner({ companyInfo = {}, reportTitle = '', dateRange, course, generatedOn }) {
  const chips = [
    dateRange   && { label: 'Period',    value: dateRange },
    course      && { label: 'Course',    value: course },
    generatedOn && { label: 'Generated', value: generatedOn },
  ].filter(Boolean);

  return (
    <div className={styles.banner}>
      <div className={styles.bannerTop}>
        <div className={styles.bannerLeft}>
          {companyInfo.logo && (
            <div className={styles.logoCircle}>
              <img src={companyInfo.logo} alt="" className={styles.logoImg} />
            </div>
          )}
          <div className={styles.companyName}>{companyInfo.name}</div>
        </div>
        <div className={styles.bannerRight}>
          {companyInfo.address && <div className={styles.bannerMeta}>{companyInfo.address}</div>}
          {companyInfo.website && <div className={styles.bannerMeta}>{companyInfo.website}</div>}
        </div>
      </div>
      <div className={styles.bannerBottom}>
        <div className={styles.reportTitle}>{reportTitle}</div>
        {chips.length > 0 && (
          <div className={styles.chips}>
            {chips.map(({ label, value }) => (
              <span key={label} className={styles.chip}>
                <span className={styles.chipLabel}>{label}:</span>
                {value}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
